// shared/ui/trashBadgeSx.js  (estilos del badge circular de imagen: quitar/eliminar; compartido por formulario y detalle)
// Badge circular arriba a la derecha (quitar pendiente / eliminar guardada).
// color con !important: sirio.css fuerza `button { color: ... !important }` y un style inline no puede ganarle.
export const removeBtnSx = {
  position: 'absolute',
  top: 6,
  right: 6,
  width: 24,
  height: 24,
  padding: 0,
  border: 'none',
  borderRadius: '50%',
  color: '#fff !important',
  background: 'rgba(0,0,0,0.55)',
  fontSize: 18,
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '&:hover': { background: 'rgba(0,0,0,0.8)' },
  '&:focus-visible': { outline: '2px solid #fff', outlineOffset: '1px' },
  '&:disabled': { opacity: 0.6, cursor: 'not-allowed', background: 'rgba(0,0,0,0.55)' },
};

export const deleteBtnSx = {
  ...removeBtnSx,
  fontSize: 12,
  boxSizing: 'border-box',
  border: '1.5px solid transparent',
  transition: 'background-color 150ms ease, border-color 150ms ease, color 150ms ease',
  '&:hover:not(:disabled), &:focus-visible:not(:disabled)': {
    background: '#FDECEC',
    borderColor: '#FDECEC',
    color: '#D92D20 !important',
  },
  '&:focus-visible': { outline: '2px solid #D92D20', outlineOffset: '1px' },
  '&:disabled': { opacity: 0.6, cursor: 'not-allowed', background: 'rgba(0,0,0,0.55)' },
};

// Estados de miniatura compartidos (subida/eliminación): velo con spinner y colores de error/marca.
export const ERROR_BORDER = '#D92D20';
export const BRAND_GREEN = '#789D16';
export const veilSx = {
  position: 'absolute',
  inset: 0,
  background: 'rgba(255,255,255,0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
